import { useEffect, useRef, useState } from "react";
import { loadSeoHead } from "@/components/SeoHead";

/** Renders an admin-configured AdSense slot. Nothing renders until a slot is enabled with code. */
export default function AdSlot({ placement, className = "" }) {
  const [slot, setSlot] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    loadSeoHead().then((data) => {
      const ads = data?.ads;
      if (!ads?.enabled) return;
      const found = (ads.slots || []).find((s) => s.placement === placement);
      if (found?.enabled && (found.code || "").trim()) setSlot(found);
    });
  }, [placement]);

  useEffect(() => {
    if (!slot || !ref.current) return;
    ref.current.innerHTML = "";
    const frag = document.createRange().createContextualFragment(slot.code);
    ref.current.appendChild(frag);
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* adsbygoogle not loaded yet */
    }
  }, [slot]);

  if (!slot) return null;

  return (
    <div
      data-testid={`ad-slot-${placement}`}
      className={`w-full flex justify-center overflow-hidden ${className}`}
      ref={ref}
    />
  );
}
